import "@rainbow-me/rainbowkit/styles.css";
import { getDefaultConfig, RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { WagmiProvider } from "wagmi";
import {
  mainnet,
  base,
  polygon,
  arbitrum,
  optimism,
} from "wagmi/chains";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";

const config = getDefaultConfig({
  appName: "Jonas Sebera Portfolio",
  projectId:
    process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || "default-project-id",
  chains: [
    mainnet,
    base,
    polygon,
    arbitrum,
    optimism,
  ],
  ssr: true,
});

const queryClient = new QueryClient();

const Web3Provider = ({ children }) => {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>{children}</RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};

export default Web3Provider;
